import { render, staticRenderFns } from "./OrderUsageTable.vue?vue&type=template&id=24ca9b8c&scoped=true&"
import script from "./OrderUsageTable.vue?vue&type=script&lang=js&"
export * from "./OrderUsageTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderUsageTable.vue?vue&type=style&index=0&id=24ca9b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca9b8c",
  null
  
)

export default component.exports